var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 13,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7187 15.5625L11.1625 9.65001C11.0736 9.60088 10.9718 9.58001 10.8707 9.59017C10.7697 9.60032 10.6741 9.64103 10.5967 9.70686C10.5193 9.77269 10.4638 9.86052 10.4376 9.95867C10.4114 10.0568 10.4157 10.1606 10.45 10.2563L12.4375 15.8313C12.4813 15.9395 12.4813 16.0605 12.4375 16.1688L10.45 21.7438C10.4157 21.8394 10.4114 21.9432 10.4376 22.0413C10.4638 22.1395 10.5193 22.2273 10.5967 22.2932C10.6741 22.359 10.7697 22.3997 10.8707 22.4098C10.9718 22.42 11.0736 22.3991 11.1625 22.35L21.7187 16.4375C21.7969 16.3943 21.862 16.3309 21.9074 16.2539C21.9528 16.177 21.9767 16.0893 21.9767 16C21.9767 15.9107 21.9528 15.823 21.9074 15.7461C21.862 15.6691 21.7969 15.6057 21.7187 15.5625Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16H16.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.e13cc6f471d7a77c7d70569f5fee88c6.svg";
export { ForwardRef as ReactComponent };